import React, { useState } from 'react'
import { postInsertCompletoSuministrosHojaGasto } from '../../../services/PaginaRuta'
import SuccessFullLiquidacion from '../liquidacion/SuccessFullLiquidacion'
import ModalErrorSuministros from './ModalErrorSuministros'
import ModalCargandoHG from './ModalCargandoHG'


const ModalSuministrosIngresoCantidad = ({setmodalOnSuministroIngresoCantidad,cantidadSuministrosCorrectos,informacionUser,passDataHojaGasto,handleCancelarClickModalCirugia}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [informacionGuardadaExitosamente, setinformacionGuardadaExitosamente] =useState(false)
  const [errorAlguardarSuministros, seterrorAlguardarSuministros]=useState(false)
  const [dataErrorSuministros, setdataErrorSuministros]=useState([])
  const [modalOnLoadingHG, setmodalOnLoadingHG]=useState(false)
  const [loading,setloading]=useState(true)
  const handleCancelarClick=()=>{
        setmodalOnSuministroIngresoCantidad(false)
    }

    

   

    const guardarSuministros=()=>{
      setloading(false)
      //setmodalOnLoadingHG(true)
      console.log(informacionUser,'informacionUserinformacionUser')
//       const insertVariablesSuministros={
//         HISCCIE: "0",                        //CIERRE DE FOLIO
//          hiscfk: "2023-07-26 00:00:00",       //Fecha de Consulta             FRONTEND
//          AnPDscDPs: "",                       //Desarrollo Psicomotor
//          HISCFCON: "2023-07-26 21:03:58.000", //Fecha de Consulta             FRONTEND
//          HISCHORA: "18:12:09     ",           //Hora del Folio                FRONTEND
//          HISCLPR: "2",                        //Clase de Procedimiento        DUDA
//          CCDOtrObs: "",                       //Observaciones de Curaci􀀁n
//          FHCIndEsp: "GN",                     //Especialidad del Folio
//          EMPCOD: "1 ",                        //Empresa
//          CNCCOD: "         ",                 //Centro Costo
//          HISCFAC: "0",                        //FACTURA
//          HISCENFACT: "",                      //Enfermedad Actual
//          RxSDscPlm: "    ",                   //Rev X Sist. Descrip Pulmonar
//          RxSDscOcu: "    ",                   //Rev.XSist. Ocular
//          RxSDscGst: "    ",                   //Rev.XSist. Gastro
//          RxSDscEnd: "    ",                   //Rev.XSist. Endocrino
//          RxSDscLcm: "    ",                   //Rev.XSist. Locomotora
//          RxSDscSNP: "    ",                   //Rev.XSist. SNP
//          EFsDscPlm: "",                       //Examen Fisico Descrip Pulmonar
//          HISFING: "2021-07-26 01:27:10.000",  //HISFING                       FRONTEND
//          HISFSAL: "2023-07-26 15:04:43.000",  //HISFSAL                       FRONTEND
//          TCnCod: "   ",                       //C􀀁digo
//          FHCCodCto: "SOSPGP        ",         //Contrato                      FRONTEND
//          FHCEst: "A",                         //Estado del Folio
//          HCEsp: "137",                        //Codigo Especialidad Medico    FRONTEND
//          HCtvIn1: "1",                        //Consecutivo de Ingreso        FRONTEND
//          HisFHorAt: "2023-07-26 21:03:58.000",//Fecha hora de atencion real de paciente FRONTEND
//          HisFolOri: "HC",                     //Origen del Folio
//          HisFolEOr: "N",                      //Estado del Folio en el Origen
//          HisFolAmb: "0",                      //Folio Origen Registro Despachos Frm Ambulatoria
//          HisCitNum: "0",                      //Numero de Cita Medica
//          HCCODPAB: "8",                       //Codigo de Pabellon            FRONTEND
//          ProEmpCod: "1 ",                     //Empresa Reserva Cirugia
//          ProCirCod: "97155",                  //No de Cirugia                 FRONTEND
//          PaqCod: "04  ",                      //C􀀁digo Paquete                FRONTEND
//          MSRESO: "10174          ",           //Producto                      FRONTEND
//          PQCvoDes: "2",                       //Consecutivo Movimiento Despacho
//          PQTpoTRN: "HG",                      //Tipo de Transacci􀀁n
//          PQFHMov: "2023-27-07 21:03:58.000",  //Fecha Hora del Movimiento     FRONTEND
//          PQCntMov: "1.0000",                  //Cantidad del Movimiento       FRONTEND
//          PQUsrMov: "CUE9F3Q8  ",              //Usuario que hace el Movimiento
//          PQEmpCod: "1 ",                      //Empresa Movimiento
//          PQCodDoc: "DES",                     //C􀀁d. Documento MovInv
//          PQPabellon: "5",                     //Pabellon Movimiento           FRONTEND
//          PqPadCed: "     ",                   //Persona que recibe Despacho
//          PQBodDes: "02  ",                    //Bodega Despacho               FRONTEND
//          PQSpsNL: "                    ",     //No. Liquidaci􀀁n Sipos(DespacharPedido)
//          PQCaSuUs:"1",                        //Cantidad de Suministro Usado  FRONTEND
//          PQUltCtvo:"",                        //Ultimo Consecutivo del Movimiento de Despacho
//          PQCaSuUsP:"0",                       //Cantidad de Suministro Usado prediligenciamiento
//          PQFecHDes:"2023-27-07 21:03:58.000", //Fecha-Hora de Despacho        BACKEND
//          TFUscS: "20",                        //Ultimo Consecutivo Suministros
//          MeCnsCnt: "1",                       //Consecutivo de Contrato
//          MsFchUlS: "2023-28-07 21:03:58.000", //Fecha Ultima Salida           FRONTEND
//          MSSldUni: "-5109",                   //Saldo Unidades
//          MSSldVlr:"-0",                       //Saldo en Valores
//          MaeVlrNoC: "1339885769",             //Valor de Notas Credito
//          MaeVlrFact:"9909041041",             //Valor Facturado
//          MaeVlrReg: "351088032",              //Valor Registrado
//          MECTope: "999999999999",             //Tope Contrato
//          PQAplSum: "s",                       //Suministro Aplicado?
//          PQAplFHor: "2023-28-07 21:03:58.000",//Fecha/Hora Aplicaci􀀁n Suministro FRONTEND IMPORANTE ME MUESTRA LA FECHA DE APLICACION SUMINISTRO
//          PQAplObs: "daniel 20 D EENERO",      //Observaci􀀁n Aplicaci􀀁n Suministro FRONTEND
//          PQAplUsu: "CUE9F3Q8",                //Usuario que aplica suministro
//          EmpCodA:"1",                         //Empresa Acta de Entrega
//          DocCodA:"DES",                       //Documento Acta de Entrega
//          DocConA: "2",                        //Consecutivo linea documento
//          DocNumAcA: "93330",                  //N􀀁mero actual de consecutivo
//          TFCedu: "16848927",                  //No. Identificaci􀀁n Usuario
//          TFTDoc: "CC",                        //Tipo de Documento
//          TmCtvIng: "6",                       //Ctvo. Ingreso           
//          TFMENi: "STOTALHOSPI",               //C􀀁digo Empresa
//          MEPSVig: "2023-07-26",               //Vigencia Portafolio Suministros
//          MENNIT: "STOTALHOSPI",               //Contrato
//          PSVigIn: "2023-07-26 ",              //Vigencia Inicial
//          CtoFchIni: "2023-07-26 00:00:00",    //Fecha Inicio Cto.
//          MeCfcha1: "2023-07-26 00:00:00",     //Fecha de finalizaci􀀁n contrato
//          HISCKEY: "16848927",                 //Tipo de Documento
//          HISTipDoc: "CC",                     //Tipo de Documento
//          DocNumEsA: "A" ,                      //Estado documento
//            PQFolPro: "",                      //Folio
//            TFVaTS: "500",                     //Valor Total Suministros 
//            TFCscS: "12",                      //Consecutivo Suministros 
//            BODEGA: "02",                      //BODEGA
//            TFFcSu: "2023-07-28 00:00:00",     //Fecha
//            TFCanS: "1",                       //Cantidad
//            TFUSum:"CUE9F3Q8",                 //Usuario Tramita Suministro 
//            TFSNDCT: "",                       //Nro.Documento
//            TFSTpoTrn: "F",                    //Tipo Transaccion
//            TFFolio: "0",                      //Folio
//            TfBodEnt: "03",                    //Bodega de Entrada
//            TfNomg:"",                          //Nombre del medicamento
//            TFvaTS1: "500",                    //Valor total Suministro particion
//            TFPorcPart:"0",                    //Porcentaje de Partici�n por Topes
//            TFEstaAnu2: "N",                   //Estado de Anulacion Suministros Anulado = 'S', No anulado = 'N' 
//            TFCenCos: "",                      //Centro de Costo
//            TFSPorIva: "0",                    //% IVA
//            TFSVlrSIv: "500",                  //Valor sin individual IVA
//            TFCODIMPS: "",                     //Codigo de impuesto para suministro
//            TFIMPSUM: "0",                     //Valor de impuesto individual 

//            ProIndUso: "",
//            ProUsuUso: "CUE9F3Q8"
//  }
      //obtener la fecha actual
    let fecha = new Date(); 

    //la fecha actual
    let fechaActual = fecha.toISOString().split('T')[0];

    //la fecha y hora actual
    let fechaHoraActual = fecha.getFullYear() + '-' + 
                      ('0' + (fecha.getMonth() + 1)).slice(-2) + '-' + 
                      ('0' + fecha.getDate()).slice(-2) + ' ' + 
                      ('0' + fecha.getHours()).slice(-2) + ':' + 
                      ('0' + fecha.getMinutes()).slice(-2) + ':' + 
                      ('0' + fecha.getSeconds()).slice(-2) + '.' + 
                      ('00' + fecha.getMilliseconds()).slice(-3);

    //hoara actual
    let horaActual = ('0' + fecha.getHours()).slice(-2) + ':' + 
                      ('0' + fecha.getMinutes()).slice(-2) + ':' + 
                      ('0' + fecha.getSeconds()).slice(-2);

    //formato de fecha AA-DD-MM    
    let fechaHoraActualFormadoAADDMM = fecha.getFullYear() + '-' + 
    ('0' + fecha.getDate()).slice(-2) + '-' + 
    ('0' + (fecha.getMonth() + 1)).slice(-2) + ' ' + 
    ('0' + fecha.getHours()).slice(-2) + ':' + 
    ('0' + fecha.getMinutes()).slice(-2) + ':' + 
    ('0' + fecha.getSeconds()).slice(-2) + '.' + 
    ('00' + fecha.getMilliseconds()).slice(-3);
    console.log(horaActual,'hora')

    //
    


const arrayTodosLosSuministros = cantidadSuministrosCorrectos.map((item)=>{
  //calcular la cantidad usuda
  let usado = 0
  if(item.PQCaSuUs === '.0000'){
    usado = 0
  }else{
    usado = parseInt(item.PQCaSuUs)
  }
  //si esta totalmente diligencia o parcialmente diligenciado
  let diligenciadoOParcialmente=''
  if(parseInt(item.PQCaSuDs) === (usado + parseInt(item.cantidad)) ){
    diligenciadoOParcialmente='D'
  }else{
    diligenciadoOParcialmente='P'
  }
  return {
          HISCCIE: "0",                       //CIERRE DE FOLIO
          hiscfk: `${fechaActual} 00:00:00`,  //Fecha de Consulta
          AnPDscDPs: "",                      //Desarrollo Psicomotor
          HISCFCON: `${fechaHoraActual}`,     //Fecha de Consulta
          HISCHORA: `${horaActual}`,          //Hora del Folio
          HISCMMED: informacionUser.ProPerSe1,
          HISCLPR: "2",                       //Clase de Procedimiento
          CCDOtrObs: "",                      //Observaciones de Curaci􀀁n
          FHCIndEsp: "GN",                    //Especialidad del Folio
          EMPCOD: usuarioInfo.Empresa,        //Empresa
          MCDpto: usuarioInfo.Sede,           //Sede
          CNCCOD: "         ",                //Centro Costo
          HISCFAC: "0",                       //FACTURA
          HISCENFACT: "",                     //Enfermedad Actual
          RxSDscPlm:"",                       //Rev X Sist. Descrip Pulmonar
          RxSDscOcu: "",                      //Rev.XSist. Ocular
          RxSDscGst: "",
          RxSDscEnd: "",
          RxSDscLcm: "",
          RxSDscSNP: "",
          EFsDscPlm: "",
          //HISFING: "2021-07-26 01:27:10.000", ///servicio postHGFechaHISFING
          //HISFSAL: "2023-07-26 15:04:43.000", ///servicios postHGFechaHISFING
          TCnCod: "   ",
          FHCCodCto: informacionUser.ProEPS,
          FHCEst: "A",
          HCEsp: informacionUser.ProEspSe1,
          HCtvIn1: "1",
          HisFHorAt: `${fechaHoraActual}`,
          HisFolOri: "HC",
          HisFolEOr: "N",
          HisFolAmb: "0",
          HisCitNum: "0",
          HCCODPAB: "8",                      //Codigo de Pabellon
          ProEmpCod: usuarioInfo.Empresa,
          ProMCDpto: usuarioInfo.Sede,
          ProCirCod: informacionUser.ProCirCod,
          PaqCod: item.PaqCod,
          MSRESO: item.MSRESO,
          //PQCvoDes: "16",
          PQTpoTRN: "HG",
          PQFHMov: `${fechaHoraActual}`,
          PQCntMov:  `${item.cantidad}.0000`,
          PQUsrMov: usuarioInfo.UsuarioEncriptado,
          PQEmpCod: usuarioInfo.Empresa,
          PQCodDoc: "DES",
          PQSedMov: usuarioInfo.Sede,
          PQPabellon: "5",                    //Pabellon Movimiento
          PqPadCed: "     ",
          PQBodDes: item.PQBodDes,
          PQSpsNL: "                    ",
          PQCaSuUs: `${parseInt(item.cantidad) + usado}.0000`,
          PQUltCtvo:"",
          PQCaSuUsP:"0",
          PQFecHDes:`${fechaHoraActual}`,
          TFUscS: "20",                     //Ultimo Consecutivo Suministros
          MeCnsCnt: "1",
          MsFchUlS: `${fechaHoraActual}`,
          MSSldUni: "-5109",
          MSSldVlr:"-0",
          MaeVlrNoC: "1339885769",
          MaeVlrFact:"9909041041",
          MaeVlrReg: "351088032",
          MECTope: "999999999999",
          PQAplSum: "S",
          PQAplFHor: `${fechaHoraActual}`, //postHGTodosLosConsecutivos
          PQAplObs: item.PQAplObs,
          PQAplUsu: usuarioInfo.UsuarioEncriptado,
          EmpCodA:usuarioInfo.Empresa,
          DocCodA:"DES",
          MCDptoA: usuarioInfo.Sede,
          DocConA: "2",                     //Consecutivo linea documento
          DocNumAcA: "93330",               //N􀀁mero actual de consecutivo
          TFCedu: informacionUser.MPCedu,
          TFTDoc: informacionUser.MPTDoc,
          TmCtvIng: informacionUser.ProCtvIn,
          TFMENi: informacionUser.ProEPS,
          MEPSVig: `${fechaActual} 00:00:00`,
          MENNIT: informacionUser.ProEPS,
          PSVigIn: `${fechaActual}`,
          CtoFchIni: `${fechaActual} 00:00:00`,
          MeCfcha1: `${fechaActual} 00:00:00`,
          HISCKEY:  informacionUser.MPCedu,
          HISTipDoc:  informacionUser.MPTDoc,
          DocNumEsA: "A",

          PQFolPro: "",
          TFVaTS: "500",
          TFCscS: "12",
          BODEGA: item.PQBodDes,
          TFFcSu: `${fechaActual} 00:00:00`,
          TFCanS: `${item.cantidad}.0000`,
          TFUSum:usuarioInfo.UsuarioEncriptado,
          TFSNDCT: "",
          TFSTpoTrn: "F",
          TFFolio: "0",
          TfBodEnt: item.PQBodDes,
          TfNomg:"",
          TFvaTS1: "500",
          TFPorcPart:"0",
          TFEstaAnu2: "N",
          TFCenCos: "",
          TFSPorIva: "0",
          TFSVlrSIv: "500",
          TFCODIMPS: "",
          TFIMPSUM: "0",

          ProIndUso: "",
          ProUsuUso: usuarioInfo.UsuarioEncriptado,
          PQEdoIte: diligenciadoOParcialmente,
          PqEdoGas: "P",                //PREGUNTAR DANIEL
          nombreSumnistro: item.MSNomG
  }
})
 const arraySuministros={
  "arraysuministrosTotales": arrayTodosLosSuministros
 }
      console.log(arraySuministros,'arraySuministros')
      
      postInsertCompletoSuministrosHojaGasto(arraySuministros).then((res)=>{
        setloading(true)
        //setmodalOnLoadingHG(false)
        console.log(res.data,'data respuesta')
        if(res.data.ArrErrores.length === 0){
          console.log(res.data,'sin error')
          setinformacionGuardadaExitosamente(true)
          //passDataHojaGasto(arraySuministros)
        }else{
          console.log(res.data,'con error')
          seterrorAlguardarSuministros(true)
          //passDataHojaGasto(arraySuministros)
          setdataErrorSuministros(res.data.ArrErrores)
        }
        
      })
       

        
       
    }
  return (
    <>
        <div
          className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
          id="exampleModalScrollable"
          tabIndex="-1"
          aria-labelledby="exampleModalScrollableLabel"
          aria-hidden="true"
        >
          <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
            <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
              
                
                                <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
                                <h5
                                  className="text-xl font-medium leading-normal text-white"
                                  id="exampleModalScrollableLabel"
                                >
                                  Tabla de suministros que se ingresaron correctamente
                                </h5>
                                <button
                                type="button"
                                onClick={handleCancelarClick}
                                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              >
                                X
                              </button>
                              </div>
                                
                
              
                              <div className="flex-auto overflow-y-auto relative p-2">
                
                              <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                          <thead className="">
                            <tr>
                              <th></th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Codigo
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Nombre
                              </th>
                              {/* <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                               Cantidad Total que puede devolver
                              </th> */}
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Cantidad Ingresada
                              </th>
                             
                              
                            </tr>
                          </thead>
                          <tbody className='rounded-none'>
                            {
                             // loading?
                                cantidadSuministrosCorrectos.map((item,index)=>(
                                    <tr className=" divide-y divide-slate-700 " key={index}>
                                        <td></td>
                                        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-center">
                                                {item.MSRESO}
                                                                                                
                                                </td>
                                                <td className="text-xs font-medium py-2 whitespace-pre-wrap text-center">
                                                {item.MSNomG}
                                                                                                
                                                </td>
                                                {/* <td className="text-xs font-medium py-2 whitespace-pre-wrap text-center">
                                                {
                                                    (()=>{
                                                        let suministroUsado = 0
                                                        if(item.PQCaSuUs === '.0000'){
                                                            suministroUsado = 0
                                                        }else if(item.PQCaSuUs !== '.0000'){
                                                            suministroUsado = parseInt(item.PQCaSuUs)
                                                        }
                                                        return (parseInt(item.PQCaSuDs) - suministroUsado)
                                                    })()
                                                }
                                                                                                
                                                </td> */}
                                                <td className="text-xs font-medium py-2 whitespace-pre-wrap text-center">
                                                {item.cantidad}
                                                                                                
                                                </td>
                                    </tr>
                                    
                                ))
                                // :
                                // <div className="relative flex items-center justify-center h-screen">      
                                //   <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25">
                                //     <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                                //       <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                //       <p className="mt-4 text-lg">Cargando</p>
                                //     </div>
                                //   </div>                              
                                // </div>
                                
                            }     

                            {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">      
                                  <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25">
                                    <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                                      <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                      <p className="mt-4 text-lg">Cargando</p>
                                    </div>
                                  </div>                              
                                </div>
                            }                 
                          
                          
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                //type="submit"
                onClick={guardarSuministros}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Confirmar
              </button>
              </div>
            </div>
          </div>
        </div>
        {informacionGuardadaExitosamente? <SuccessFullLiquidacion setinformacionGuardadaExitosamente={setinformacionGuardadaExitosamente} handleCancelarClickSuministros={handleCancelarClick} handleCancelarClickModalCirugia={handleCancelarClickModalCirugia} passDataHojaGasto={passDataHojaGasto} cantidadSuministrosCorrectos={cantidadSuministrosCorrectos}/>:null}
        {errorAlguardarSuministros? <ModalErrorSuministros dataErrorSuministros={dataErrorSuministros} seterrorAlguardarSuministros={seterrorAlguardarSuministros} handleCancelarClickSuministros={handleCancelarClick} handleCancelarClickModalCirugia={handleCancelarClickModalCirugia} passDataHojaGasto={passDataHojaGasto} cantidadSuministrosCorrectos={cantidadSuministrosCorrectos}/>:null}
     
                </>
  )
}

export default ModalSuministrosIngresoCantidad